import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {GlobalMessagesService} from '../../services/messages/global.messages.service';
import {MessageService, Message} from 'primeng/api';

@Component({
  selector: 'wsd-global-messages',
  templateUrl: './global-messages.component.html',
  styleUrls: ['./global-messages.component.css'],
  providers: [MessageService]
})
export class GlobalMessagesComponent implements OnInit, OnDestroy {

  @Input()
  life: number;

  globalMsg: Message[] = [];

  private subscription: Subscription;

  constructor(private globalMessageService: GlobalMessagesService, private messageService: MessageService) { }

  ngOnInit() {
    this.subscription = this.globalMessageService.messageSent$.subscribe(
      (msg: Message) => {
        this.showMessage(msg);
      }
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private showMessage(msg: Message) {
    this.messageService.add(msg);
  }

}
